export const enum ConfigureProductPageMenuModes {
  HOME,
  CHANGE_MATERIALS,
  ADD_SECTION,
  WALLS,
  ADD_DECORATION
}
